// File: frontend/src/components/layout/DashboardLayout.js

import React from 'react';
import DashboardHeader from './DashboardHeader';
import DashboardFooter from './DashboardFooter';
import styles from './DashboardLayout.module.css';

const DashboardLayout = ({ children }) => {
  return (
    <div className={styles.dashboardLayout}>
      <DashboardHeader />
      <main className={styles.mainContent}>
        {children}
      </main>
      <DashboardFooter />
    </div>
  );
};

export default DashboardLayout;